// export * from './loader.component';
export * from './loader.module';
